import { GzPolicyPanelAccordionButtonsWebComponent } from './component/GzPolicyPanelAccordionButtonsWebComponent';

export { GzPolicyPanelAccordionButtonsWebComponent };
